import { MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Rights, UserProfileModel, UserService } from 'src/app/core/services/api-services';
import { BaseComponent } from '../../../core/components/base.component';
import { AppConfigService } from '../../../core/services/app-config.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { AvatarUpdateService } from 'src/app/core/services/avatar-update.service';

@Component({
  selector: 'app-site-template',
  templateUrl: './site-template.component.html',
  styleUrls: ['./site-template.component.scss']
})
export class SiteTemplateComponent extends BaseComponent implements OnInit {
  readonly sideMenuExpanded: string = "sideMenuExpanded";
  readonly sideMenuCollapsed: string = "sideMenuCollapsed";

  userInfo: UserProfileModel | null = null;
  isAuthenticated: boolean = false;
  displayName: string | null = null;
  displayEmail: string | null = null;
  loginLabel: string = "Navigation.Login";
  collapsed: boolean = false;
  isAdminRoute$ = new BehaviorSubject<boolean | null>(null);
  hasAdminRights: boolean = false;
  logoUrl: string | null = null;
  userImgSrc: string | null = null;
  sideMenuClass: string = '';
  mobileMedia: any;
  
  constructor(private readonly authenticationService: AuthenticationService,
    private readonly appConfigService: AppConfigService,
    private readonly userService: UserService,
    private readonly avatarUpdateService: AvatarUpdateService,
    mediaMatcher: MediaMatcher,
    private readonly router: Router) {
      super();
      this.mobileMedia = mediaMatcher.matchMedia("(min-width: 100px) and (max-width: 900px)");
  }

  ngOnInit(): void {
    const apiUrl = this.appConfigService.getConfig().apiUrl;
    this.logoUrl = this.getLogoUrl(apiUrl);

    if(this.authenticationService.getHasToMfa()){
      this.router.navigate([this.authenticationService.getMfaUrl()]); // Redirect to mfa
    }

    if(this.authenticationService.isAuthenticated() && !this.authenticationService.getHasToMfa()){
      this.hasAdminRights = this.authenticationService.hasRight(Rights.SystemAdministrator);

      this.userService.getUserProfile()
          .unsubscribeOnDestroy(this)
          .subscribe((model) => {
            this.isAuthenticated = this.authenticationService.isAuthenticated();
            this.userInfo = model;
            this.displayName = `${model?.firstname} ${model?.lastname}`;
          });
    }

    this.router.events
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value instanceof NavigationEnd) {
          this.isAdminRoute$.next(this.getIsAdminRoute(value.url));
        }
      });

    this.isAdminRoute$.next(this.getIsAdminRoute(this.router.url));

    if(this.mobileMedia.matches){
      this.collapsed = true;
      this.sideMenuClass = this.sideMenuCollapsed;
    }
    else{
      this.sideMenuClass = this.sideMenuExpanded;
    }

    // Receiving avatar updates
    this.avatarUpdateService.getProfileUpdate$
      .unsubscribeOnDestroy(this)
      .subscribe((result) => {
        this.ngOnInit();
      })
  }

  onLogin() {
    this.router.navigate([this.authenticationService.getLoginUrl()]);
  }

  myProfile() {
    if(this.mobileMedia.matches){
      this.collapse();
    }
    this.router.navigate(['profile']);
  }

  private getLogoUrl(apiUrl: string): string {
    return `${apiUrl}/api/theme/logo`;
  }

  private getIsAdminRoute(url: string): boolean {
    return url.includes('admin');
  }

  logout(): void {
    this.authenticationService.logout();
    this.isAuthenticated = false;
    this.userInfo = null;

    this.onMobileClickCollapse();
    this.ngOnInit();
    this.router.navigate(['/']);
  }

  onMobileClickCollapse(): void {
    if(this.mobileMedia.matches){
      this.collapse();
    }
  }

  collapse(): void {
    this.collapsed = !this.collapsed;
    if(this.collapsed){
      this.sideMenuClass = this.sideMenuCollapsed;
    }
    else{
      this.sideMenuClass = this.sideMenuExpanded;
    }
  }
}
